<template>
  <div class="score_rule_container">
    <div class="score_rule_box">
      <div class="h2">积分规则</div>
      <div class="rule_list">
        <p>1、每日签到：</p>
        <p>连续签到 1 天，积分值 1，经验值 1；</p>
        <p>连续签到 2 天，积分值 2，经验值 2；</p>
        <p>连续签到 3 天，积分值 3，经验值 3；</p>
        <p>连续签到 4 天，积分值 4，经验值 4；</p>
        <p>连续签到 5 天，积分值 5，经验值 5；</p>
        <p>连续签到 6 天，积分值 6，经验值 6；</p>
        <p>连续签到 7 天，积分值 7，经验值 7；</p>
        <p>2、新用户注册成功，积分值 50，经验值 2；</p>
        <p>3、发表评论并通过审核，每日限制 3 次，积分值 10，经验值 5，每日上限（积分 30 /经验 15）；</p>
        <p>4、提交报料并审核通过，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>5、欣赏广告，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>6、分享内容，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>7、邀请送积分，每日限制 20 次，积分值 100，经验值 10，每日上限（积分 2000/经验 200）；</p>
        <p>8、浏览内容，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>9、参与投票，每日限制 3 次，积分值 5，经验值 1，每日上限（积分 15/经验 3）；</p>
        <p>10、提交活动作品并通过审核，每日限制 1 次，积分值 10，经验值 2，每日上限（积分 10/经验 2）；</p>
        <p>11、每日打开客户端，每日限制 1 次，积分值 10，经验值 1，每日上限（积分 10/经验 1）；</p>
        <p>12、观看视频，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>13、直播间，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>14、新手任务，每日限制 1 次，积分值 50，经验值 10，每日上限（积分 50/经验 10）；</p>
        <p>15、订阅，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>16、点赞，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/经验 3）；</p>
        <p>17、关注自媒体，每日限制 3 次，积分值 2，经验值 1，每日上限（积分 6/ 经验 3）；</p>
        <p>18、收藏，每日限制 3 次，积分值 2， 经验值 1，每日上限（积分 6/经验 3）。</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "ScoreRule",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "积分规则", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = "积分规则";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.score_rule_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #000;
  * {
    word-break: normal;
    white-space: normal;
    line-height: 24px;
    // font-family: "宋体";
  }
  .score_rule_box {
    .h2 {
      padding: 18px 0;
      text-align: center;
      font-size: 18px;
      font-weight: bolder;
    }
    .rule_list {
      p {
        margin: 5px 0;
        text-indent: 2em;
        font-size: 14px;
      }
    }
  }
}
</style>